"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chevron = void 0;
const react_1 = require("react");
const React = require("react");
const transform = {
    down: "translate(0, 0) rotate(0)",
    up: "translate(20, 20) rotate(180)",
    left: "translate(20, 0) rotate(90)",
    right: "translate(0, 20) rotate(270)"
};
class Chevron extends react_1.Component {
    render() {
        const { direction = "down" } = this.props;
        return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20" },
            React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "#26324E", strokeLinecap: "square", transform: transform[direction] },
                React.createElement("path", { d: "M4.667 7.667L10 13M15.333 7.667L10 13" }))));
    }
}
exports.Chevron = Chevron;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/chevron.tsx
// module id = 2133
// module chunks = 0 1 2